import React, { useEffect, useState } from 'react';

import loadingImg from '@/assets/loading_2.gif';
import { qsParse } from '@/utils';
import bus from '@/utils/bus';

import styles from './index.module.scss';

export const PAGE_PROGRESS_EVENT_NAME = 'hide-page-progress';

const PageProcess = React.memo((): JSX.Element | null => {
  const [visibility, setVisibility] = useState(true);
  const [num, setNum] = useState(0);

  const query = qsParse() || {};
  const { pScene } = query;

  useEffect(() => {
    const event = () => {
      setVisibility(false);
    };

    bus.on(PAGE_PROGRESS_EVENT_NAME, event);

    return () => {
      bus.off(PAGE_PROGRESS_EVENT_NAME, event);
    };
  }, []);

  useEffect(() => {
    if (pScene === '1') {
      const now = num + 3;
      if (now <= 99) {
        setTimeout(() => {
          setNum(now);
        }, 30);
      }
    }
  }, [num]);

  if (pScene !== '1') return null;

  return (
    <div className={styles['page-progress']} style={{ display: visibility ? 'flex' : 'none' }}>
      <img src={loadingImg} />
      <div className={styles.text}>叫叫正在制作您的专属海报</div>
      <div className={styles.bar}>
        <div className={styles.progress}>
          <div className={styles.step} style={{ width: `${num}%` }} />
        </div>
        <div className={styles.progressText}>{num}%</div>
      </div>
    </div>
  );
});

export default PageProcess;
